import * as React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  Grid,
} from '@mui/material';
import PropTypes from 'prop-types';

const boldText = {
  fontSize: '17px',
  lineHeight: '22px',
  fontFamily: '"SF Pro Text Semibold", sans-serif',
};
const descStyle4 = {
  fontSize: '13px',
  lineHeight: '16px',
  letterSpacing: '-0.078px',
  marginBottom: '19px',
};
const buttonStyle4 = {
  textTransform: 'none',
  fontSize: '17px',
  color: '#007AFF',
  lineHeight: '17px',
};
function WazePopup({ setOpen, data }) {
  const handleClose = () => {
    setOpen(false);
  };
  const handleWaze = (e) => {
    setOpen(false);
    e.preventDefault();
    window.open(
      `https://waze.com/ul?ll=${data.latitude},${data.longitude}&q=66+&navigate=yes`
    );
  };

  return (
    <React.Fragment>
      <Dialog
        sx={{
          '& .MuiDialogContent-root ': { padding: '0px 0px', margin: 0 },
          '& .css-1t1j96h-MuiPaper-root-MuiDialog-paper ': {
            margin: '19px',
            borderRadius: '14px',
          },
        }}
        width={React.useState(true)}
        margin={0}
        open={true}
        onClose={handleClose}
      >
        <DialogContent
          sx={{
            '& .MuiDialogContent-root ': { padding: '51px 1px' },
            '& .MuiDialog-paper  ': { margin: '1px', width: '20px' },
            width: '270px',
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            background="#FAFAFA"
            backdropFilter="blur(27.1828px)"
            textAlign="center"
            fontFamily="'SF Pro Text Regular', sans-serif"
            letterSpacing="-0.408px"
          >
            <Box
              sx={{
                pt: '19px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Box sx={{ mb: '2px' }} style={boldText}>
                Search for route via Waze?
              </Box>
              <Box style={descStyle4}>This will open the Waze app</Box>

              <Divider orientation="horizontal" flexItem></Divider>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  maxWidth: '270px',
                  width: '100%',
                  height: '45px',
                }}
              >
                <Button
                  onClick={handleClose}
                  variant="text"
                  sx={{
                    width: '100%',
                    padding: '10.5px 38.5px 11px 38px',
                    borderColor: '#054E8B',
                    letterSpacing: 'inherit',
                    ':hover': {
                      bgcolor: '#ffffff',
                    },
                  }}
                  style={buttonStyle4}
                >
                  Decline
                </Button>
                <Divider orientation="vertical" flexItem></Divider>
                <Button
                  onClick={(e) => handleWaze(e)}
                  variant="text"
                  sx={{
                    width: '100%',
                    padding: '10.5px 39px 11px',
                    textTransform: 'none',
                    letterSpacing: 'inherit',
                    color: '#007AFF',
                    ':hover': { bgcolor: '#ffffff', color: '#000000' },
                  }}
                  style={boldText}
                >
                  Accept
                </Button>
              </Box>
            </Box>
          </Grid>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
WazePopup.propTypes = {
  setOpen: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};
export default WazePopup;
